import type { KioskStore } from "@/app/stores/kiosk";
import type { BillStore } from "@/data/stores/bill";
import type { CartStore } from "@/data/stores/cart";
import type { CartPaymentStore } from "@/data/stores/cartPayment";
import type { IdentityStore } from "@/data/stores/identity";
import type { OfferStore } from "@/data/stores/offer";
import type { OperatorSettingsStore } from "@/data/stores/operatorSettings";
import type { PaymentStore } from "@/data/stores/payment";
import type { PrintStore } from "@/data/stores/print";
import type { TableAllocationStore } from "@/data/stores/tableAllocation";
import type { ArticleAttribute } from "@/data/stores/articleAttribute";
import type { OrderedArticlesStore } from "@/data/stores/orderedArticles";

export const globalStores = {
    billStore: undefined as BillStore | undefined,
    cartStore: undefined as CartStore | undefined,
    cartPaymentStore: undefined as CartPaymentStore | undefined,
    identityStore: undefined as IdentityStore | undefined,
    kioskStore: undefined as KioskStore | undefined,
    offerStore: undefined as OfferStore | undefined,
    operatorSettingsStore: undefined as OperatorSettingsStore | undefined,
    paymentStore: undefined as PaymentStore | undefined,
    printStore: undefined as PrintStore | undefined,
    tableAllocationStore: undefined as TableAllocationStore | undefined,
    articleAttributeStore: undefined as ArticleAttribute | undefined,
    orderedArticlesStore: undefined as OrderedArticlesStore | undefined,
};
